@if (shown(); as text) {
  <div class="toast" role="status">
    <svg
      class="toast__icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.4"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12.5l4.5 4.5L19 7.5" />
    </svg>
    <span>{{ text }}</span>
  </div>
}
